import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Part 1: one column of section cards next to the image.
export const CaseSectionStack = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`;

// Part 2: full width, two columns on wide screens; LET'S TALK and an unpaired last card span the row.
export const CaseSectionGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  width: 100%;

  & > [data-wide] {
    grid-column: 1 / -1;
  }

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const CaseSection = styled(Box)`
  box-sizing: border-box;
  padding: 14px 18px;
  border: 1px solid var(--brand-border, #E5E7EB);
  border-left: 4px solid #EE6D29;
  border-radius: 12px;
  background: var(--brand-surface, #fff);
  text-align: left;
  font-size: 17px;
  line-height: 1.55;
  color: var(--brand-text, #374151);

  ul,
  ol {
    margin: 0;
    padding-left: 22px;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  li {
    margin: 4px 0;
  }
`;

export const CaseSectionLabel = styled(Box)`
  margin-bottom: 6px;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #0097B2;
`;

export const CaseChoice = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
`;

// Static A/B/C marker (same shape as PollOptionBadge, no selection state).
export const CaseChoiceBadge = styled(Box)`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
  border: 1.5px solid #0097B2;
  color: #0097B2;
`;
